import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/zoningPermit.png';

function ZoningPermitsServices() {
  const [Faq, setFaq] = useState(0); // first dropdown open by default
  const titleRef = useRef(null);
  const [titleColor, setTitleColor] = useState('');

  useEffect(() => {
    if (titleRef.current) {
      const c = window.getComputedStyle(titleRef.current).color;
      setTitleColor(c);
    }
  }, []);

  // match reference page structure/styles
  const liRow = { display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '12px' };
  const icon = { marginTop: '4px', flex: '0 0 auto' };
  const kv = { display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: 0 };
  const keyText = { fontWeight: 700, fontSize: '1.1rem', lineHeight: 1.35, color: '#0f172a' };
  const valText = { fontSize: '1rem', lineHeight: 1.6, color: '#334155' };
  const overviewText = { color: titleColor || '#0f172a', fontSize: '1.05rem', lineHeight: 1.6, margin: '8px 0 16px' };

  const sections = [
    {
      Que: 'Do I Need a Permit?',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Work that typically requires permits:</span>
              <span style={valText}>
                New construction; additions; garages/sheds over threshold size; decks and porches; pools; retaining walls; signs; grading; demolition; changes of use; and most commercial tenant improvements.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Common exemptions:</span>
              <span style={valText}>
                Cosmetic, like-for-like interior finishes (paint, flooring), small non-structural repairs, and portable accessories below size/height limits. Always confirm before starting work.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Common Permit Types',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Zoning Clearance:</span>
              <span style={valText}>
                Verifies use, setbacks, height, lot coverage, and parking compliance before a building permit is issued.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Building/Trade Permits:</span>
              <span style={valText}>
                Required for structural, electrical, plumbing, mechanical work, and most changes to life-safety systems.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Sign & Temporary Use Permits:</span>
              <span style={valText}>
                For permanent/temporary signage and short-term events (pop-ups, seasonal sales) with site/traffic controls.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Home Occupation:</span>
              <span style={valText}>
                Allows limited business activity within a dwelling when neighborhood impact standards are met.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'How to Apply',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>1) Pre-application (optional but recommended):</span>
              <span style={valText}>
                Meet with Zoning & Permits to confirm requirements, timelines, and whether your project is by-right or needs a variance.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>2) Prepare submittals:</span>
              <span style={valText}>
                Site plan, floor plans/elevations, surveys, calculations (as applicable), and any specialty approvals (e.g., historic).
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>3) Submit & pay fees:</span>
              <span style={valText}>
                Apply online or at the permit counter, pay application/plan-review fees, and track review status in the portal.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>4) Plan review & corrections:</span>
              <span style={valText}>
                Respond to comments; resubmit revised documents. Once approved, your permit is issued for construction to begin.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Submittal Requirements (Typical)',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Site plan & survey:</span>
              <span style={valText}>
                Show property lines, setbacks, easements, utilities, parking/driveways, grading and drainage where applicable.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Architectural/engineering documents:</span>
              <span style={valText}>
                Floor plans, elevations, sections, structural calcs (if needed), and energy/accessibility compliance notes.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Special approvals:</span>
              <span style={valText}>
                HOA letters (if required), historic certificates, floodplain analysis, and state/federal permits (as applicable).
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Timelines & Expedited Options',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Typical review windows:</span>
              <span style={valText}>
                Small residential projects are often reviewed within a few business days; larger commercial or complex projects take longer and may require multiple disciplines.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Expedite programs:</span>
              <span style={valText}>
                Limited slots for qualified projects (e.g., life-safety, small residential, or economic-development projects). Additional fees may apply.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Setbacks, Height & Lot Coverage',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Check your zoning district:</span>
              <span style={valText}>
                Each district sets minimum setbacks, maximum height, floor area, and lot coverage. Corner lots and easements can change what’s allowed.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Accessory structures & ADUs:</span>
              <span style={valText}>
                Often allowed in rear yards with lower height and size limits. Separate utility and parking rules may apply.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Inspections & Final Approvals',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Scheduling:</span>
              <span style={valText}>
                Call or use the portal to request inspections (foundation, framing, rough trades, final). Do not cover work before it’s inspected.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Certificate of Occupancy:</span>
              <span style={valText}>
                Issued after final inspections and compliance sign-offs. Required before opening a business or moving in (when applicable).
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Variances, Appeals & Public Hearings',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>When needed:</span>
              <span style={valText}>
                If a project cannot meet specific dimensional standards due to unique site conditions, you may request a variance through the Board of Zoning Appeals.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Process:</span>
              <span style={valText}>
                Staff review, public notice, and a hearing. Decisions may include conditions to address impacts on neighbors and public safety.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    // Fee highlights kept visible; application PDFs moved to the Forms hub
    {
      Que: 'Fee Schedule Highlights',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Plan review fee:', '15% of the total permit fee (separate and non-refundable).'],
            ['Re-inspection:', '$50 after the second failed inspection.'],
            ['Certificate of Occupancy:', '$50 for a permanent certificate.'],
            ['Demolition permit:', '$100.'],
            ['Work without permit penalty:', 'Double the original permit fee.'],
          ].map(([k, v], i) => (
            <li key={`fees-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}>
                <span style={keyText}>{k}</span>
                <span style={valText}>{v}</span>
              </div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Permit Valuation Tiers (Quick View)',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['$0 – $1,000:', '$50 flat fee.'],
            ['$1,001 – $25,000:', '$50 for the first $1,000, plus $8 for each additional $1,000 (or fraction).'],
            ['$25,001 – $100,000:', '$250 for the first $25,000, plus $6 for each additional $1,000 (or fraction).'],
            ['$100,001 – $500,000:', '$650 for the first $100,000, plus $4 for each additional $1,000 (or fraction).'],
            ['$500,001 and up:', '$2,250 for the first $500,000, plus $3 for each additional $1,000 (or fraction).'],
          ].map(([k, v], i) => (
            <li key={`tier-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}>
                <span style={keyText}>{k}</span>
                <span style={valText}>{v}</span>
              </div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Which Form Do I Use?',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Pick on the Forms Hub:</span>
              <span style={valText}>
                Choose your permit type on the Forms & Applications page (e.g., Commercial, or 1 & 2 Family Residential). Each option includes a downloadable PDF and an online webform so you can submit details directly.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Contact & Help',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Zoning & Permits Counter:</span>
              <span style={valText}>
                Mon–Fri, standard business hours. Email <u>zoning.permits@gts.gov</u> or call (123) 555-0149 for questions or pre-app appointments.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
  ];

  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img
                src={SubDeptImage}
                className="img-fluid"
                alt="Zoning and Permits Services"
              />
            </div>

            <div className="department-details-content-box">
              <h4 ref={titleRef} className="department-details-title">
                Zoning and Permits Services
              </h4>

              {/* Overview (always visible, same color as title but smaller) */}
              <p style={overviewText}>
                We guide residents, builders, and businesses through zoning rules and permits—so projects meet safety,
                design, and neighborhood standards. From simple home improvements to commercial build-outs, we help you
                understand what’s allowed and how to get approved.
              </p>

              {/* Actions: keep fees PDF, move applications to Forms hub */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', margin: '0 0 16px' }}>
                <a 
                  href="/guides/StateofGTSZoningPermitFees2025.pdf" 
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  Download Zoning & Permit Fees (PDF)
                </a>
                <Link
                  to="/forms"
                  className="btn btn-secondary d-inline-flex align-items-center justify-content-center"
                >
                  Apply for a Permit (Online Forms)
                </Link>
              </div>
            </div>

            {/* Accordion (expanded information) */}
            <div className="accordian-box">
              {sections.map((item, index) => (
                <div className={`accordian-box-item ${Faq !== index && 'active'}`} key={index}>
                  <div className="accordian-title">
                    <h5>{item.Que}</h5>
                    <i
                      className="fa-solid fa-angle-right"
                      onClick={() => setFaq(index)}
                      role="button"
                      aria-label={`Toggle ${item.Que}`}
                    />
                  </div>

                  {Faq === index && (
                    <div className="accordian-content" style={{ display: 'block' }}>
                      {item.Answer}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div style={{ marginTop: 12 }}>
              <Link to="/department/housing">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default ZoningPermitsServices;
